module.exports = __webpack_public_path__ + "img/logoTextAllWhite.dfc76827.svg";